export default ({ pnr, tierLevel, ffProgram, actionType, spid, storefront }) => {
  return {
    event: 'CorporatePNRLookup',
    pnr: pnr,
    tierLvl: tierLevel ? tierLevel : 'No FF',
    ffProgram: ffProgram ? ffProgram : 'No FF',
    actionType: actionType,
    spid: spid ? spid : 'NA',
    storefront: storefront,
  };
};